"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core/");
var _Alert = _interopRequireDefault(require("@material-ui/lab/Alert"));
var _reactI18next = require("react-i18next");
var _input = _interopRequireDefault(require("../form/input"));
var _textarea = _interopRequireDefault(require("../form/textarea"));
var _userContext = _interopRequireDefault(require("../../context/userContext"));
var _svgicon = _interopRequireDefault(require("../../helper/svgicon"));
var _switch = _interopRequireDefault(require("../switch"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _core.makeStyles)(theme => ({
  container: {
    border: "1px solid",
    borderColor: theme.palette.lateCheckOut
  },
  iconWrapper: {
    background: theme.palette.lateCheckOut,
    padding: theme.spacing(3, 1.5, 1.5, 1.5),
    textAlign: "center",
    "& svg": {
      color: theme.palette.getContrastText(theme.palette.lateCheckOut)
    }
  },
  iconLabel: {
    color: theme.palette.getContrastText(theme.palette.lateCheckOut),
    marginTop: theme.spacing(2)
  },
  switchWrapper: {
    padding: theme.spacing(3.5, 4, 2.5, 4),
    textAlign: "center"
  },
  formContainer: {
    border: "1px solid",
    borderColor: theme.palette.lateCheckOut,
    borderTop: 0,
    display: "block"
  },
  form: {
    padding: theme.spacing(5)
  },
  formControl: {
    marginBottom: theme.spacing(0.5),
    "& .MuiFilledInput-root": {
      background: theme.palette.background.input
    },
    "& .MuiFilledInput-underline:before": {
      display: "none"
    }
  },
  inputLabel: {
    marginBottom: theme.spacing(-2)
  }
}));
const LateCheckOut = () => {
  const [show, setShow] = (0, _react.useState)(false);
  const {
    i18n
  } = (0, _reactI18next.useTranslation)();
  const [userData] = (0, _react.useContext)(_userContext.default);
  const [formError, setFormError] = (0, _react.useState)(false);
  const css = useStyles();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const theme = (0, _core.useTheme)();
  if (!userData) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  const {
    email,
    lastname,
    roomNumber
  } = userData || {};
  const handleChange = event => {
    setShow(event.target.checked);
  };
  const handleSubmit = event => {
    event.preventDefault();
    const {
      REACT_APP_PATH,
      REACT_APP_LATECHECKOUT_RECEIVER
    } = process.env;
    const formData = new FormData(event.target);
    formData.append("layout", "mail");
    formData.append("lang", i18n.language);
    formData.append("receiver", REACT_APP_LATECHECKOUT_RECEIVER);
    formData.append("subject", "Late Checkout");
    formData.append("redir", "/");
    formData.append("fields", "lastname=Nachname;roomnumber=Zimmernummer;message=Nachricht");
    if (email) formData.append("replyto", email);
    fetch(REACT_APP_PATH + "/sendmail.api", {
      body: formData,
      method: "POST"
    }).then(response => {
      if (response.status === 200) {
        window.location.href = "/".concat(i18n.language, "/late-checkout-success.html");
      } else {
        setFormError(true);
      }
    });
  };
  if (!userData) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    className: css.container
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.iconWrapper,
    item: true,
    xs: 4
  }, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    src: "/img/icons/leaf.svg",
    size: 32
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.iconLabel,
    variant: "h3"
  }, t("site.lateCheckOut.headline"))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.switchWrapper,
    item: true,
    xs: 8
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.switchLabel,
    variant: "h3"
  }, t("site.lateCheckOut.activate")), /*#__PURE__*/_react.default.createElement(_switch.default, {
    checked: show,
    onChange: handleChange,
    variant: theme.palette.lateCheckOut
  }))), /*#__PURE__*/_react.default.createElement(_core.Collapse, {
    in: show
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    className: css.formContainer
  }, /*#__PURE__*/_react.default.createElement("form", {
    className: css.form,
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(_input.default, {
    name: "lastname",
    label: i18n.language === "de" ? "Nachname" : "Lastname",
    required: true,
    defaultValue: lastname
  })), /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 3
  }, /*#__PURE__*/_react.default.createElement(_input.default, {
    name: "roomnumber",
    label: i18n.language === "de" ? "Zimmernummer" : "Room number",
    defaultValue: roomNumber,
    required: true
  })), /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 3
  }, /*#__PURE__*/_react.default.createElement(_textarea.default, {
    name: "message",
    label: i18n.language === "de" ? "Anmerkungen" : "Notes"
  })), formError && /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 3
  }, /*#__PURE__*/_react.default.createElement(_Alert.default, {
    severity: "error"
  }, i18n.language === "de" ? "Leider konnte die Nachricht nicht übermittelt werden, bitte melden Sie Ihren Late Check-Out-Wunsch direkt an der Rezeption." : "Unfortunately the message could not be transmitted, please report your request directly to reception.")), /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: "flex",
    justifyContent: "flex-end",
    mt: 3
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    type: "submit",
    variant: "contained",
    color: "primary"
  }, t("site.lateCheckOut.submit")))))));
};
var _default = exports.default = LateCheckOut;